import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DEFAULT_NAVIGATION_EXTRAS } from '®shared/router/navigation-utils';

@Component({
  selector: 'rl-section-mode-resolver',
  template: '<rl-loader></rl-loader>',
})
export class SectionModeResolverComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.router.navigate(['modes', 'view'], {
      ...DEFAULT_NAVIGATION_EXTRAS,
      relativeTo: this.activatedRoute,
    });
  }
}
